export default "__VITE_ASSET__B769LskJ__"